<template>
    <img v-if="$store.state.formSuccess" :src="$store.state.formSuccess && $store.state.argann != '' ? `https://action.metaffiliation.com/trk.php?mclic=${ $store.state.courseInfo.pixel }&argann=${ $store.state.argann }&altid=${ $store.state.altid }` : ''" width="1" height="1" border="0"/>
</template>

<script>
export default {
    name: 'Pixel',
};
</script>

<style>

</style>
